import React from 'react';
import Navbar from '../components/Navbar';
import './Privacy.css';

function Privacy() {
    return (
        <div className="page-container privacy-page">
            <Navbar />

            <section className="privacy-hero">
                <div className="container">
                    <div className="privacy-hero-content">
                        <span className="section-badge">ЮРИДИЧЕСКАЯ ИНФОРМАЦИЯ</span>
                        <h1 className="privacy-title">
                            Политика <span className="gradient-text">конфиденциальности</span>
                        </h1>
                        <p className="privacy-subtitle">
                            Последнее обновление: 19 марта 2026 г.
                        </p>
                    </div>
                </div>
            </section>

            <section className="privacy-content">
                <div className="container">
                    <div className="privacy-wrapper">
                        <div className="privacy-section">
                            <p>
                                Настоящая политика конфиденциальности (далее — «Политика») определяет порядок, в котором платформа собирает, использует, хранит и раскрывает информацию о пользователях.
                                В ней также описываются методы, применяемые нами к такой информации, ваши права на конфиденциальность и возможности выбора в отношении ваших данных.
                                Для ясности, данная Политика распространяется на всех пользователей платформы (далее — «Ученики», «Вы»).
                            </p>
                            <p>
                                Получая доступ к платформе и используя ее, предоставляя свои личные данные или выражая согласие при предоставлении выбора, вы соглашаетесь на сбор, использование и раскрытие информации в соответствии с данной Политикой и Условиями использования. Мы не несем ответственности, вытекающей из ваших действий.
                                Если вы не согласны с каким-либо положением данной Политики и/или Условий использования, воздержитесь от доступа к платформе и использования ее сервисов и немедленно покиньте ее.
                                Если предоставленная вами информация нарушает условия данной Политики или Условий использования, мы можем удалить ее и ограничить ваш доступ к платформе без уведомления и ответственности перед вами.
                                Термины, используемые в данной Политике, но не имеющие определения, следует толковать в соответствии с нашими Условиями использования.
                                Пожалуйста, внимательно ознакомьтесь с Политикой перед использованием наших услуг. В случае вопросов свяжитесь с нами по указанным контактам.
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>Личная информация</h2>
                            <p>
                                «Личная информация» означает данные, идентифицирующие Ученика, такие как имя и фамилия, идентификационный номер, адрес электронной почты, возраст, пол, местоположение, фотографии и/или номер телефона, предоставленные при регистрации или позже.
                            </p>
                            <p>
                                «Конфиденциальная личная информация» включает: (i) пароли и финансовые данные (кроме последних 4 цифр карт), (ii) данные о здоровье, (iii) государственные идентификаторы (биометрия, ИНН, СНИЛС, паспортные данные), (iv) данные о сексуальной ориентации, расе, политических или религиозных убеждениях, (v) детали учетной записи, или (vi) любые данные, классифицируемые как «особые категории данных» согласно GDPR, CCPA или другим применимым законам о защите данных.
                            </p>
                            <p>
                                Использование термина «Личная информация» включает в себя «Конфиденциальную личную информацию», когда это применимо по контексту.
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>Информация, которую мы собираем</h2>
                            <p>
                                Мы можем собирать как личную, так и неличную информацию различными способами, включая посещение платформы, регистрацию и другие действия, связанные с нашими услугами. Обратите внимание на следующее:
                            </p>
                            <ul>
                                <li>Мы не запрашиваем личную информацию, если она не является действительно необходимой (например, для регистрации).</li>
                                <li>Мы не передаем вашу личную информацию третьим лицам, за исключением случаев соблюдения закона, разработки продуктов или защиты наших прав.</li>
                                <li>Мы храним личную информацию на серверах только до тех пор, пока это необходимо для работы платформы.</li>
                                <li>Для загрузки пользовательского контента используется https://spayeeservers1.com.</li>
                            </ul>

                            <p><strong>Лично идентифицируемая информация:</strong> Мы можем собирать такую информацию (имя, email) только если вы предоставляете ее добровольно. Вы можете отказаться, но это может ограничить доступ к некоторым функциям платформы.</p>

                            <p><strong>Неличная информация:</strong> При использовании платформы мы можем собирать технические данные: название браузера, языковые настройки, тип ОС, интернет-провайдер и другие подобные сведения.</p>

                            <p><strong>Файлы Cookie:</strong> Наша платформа может использовать файлы «cookie» для улучшения пользовательского опыта. Вы можете отключить их в настройках браузера, но это может повлиять на корректность работы некоторых частей сайта.</p>
                        </div>

                        <div className="privacy-section">
                            <h2>Как мы используем и передаем информацию</h2>
                            <p>Мы используем информацию в следующих целях:</p>
                            <ul>
                                <li><strong>Для обеспечения доступа:</strong> Для поддержки клиентов, обработки покупок, проверки данных и решения технических проблем на платформе.</li>
                                <li><strong>Для улучшения и безопасности:</strong> Для анализа использования сайта, настройки персонализации и предотвращения мошенничества или злоупотреблений сетью.</li>
                                <li><strong>Для связи и маркетинга:</strong> Мы можем использовать ваш email для уведомлений о заказах, новостях, новых продуктах или для получения обратной связи.</li>
                            </ul>
                            <p>Мы не продаем и не обмениваем вашу личную информацию. Мы можем делиться общими агрегированными демографическими данными, не связанными с конкретными персонами, с нашими партнерами в указанных выше целях.</p>
                        </div>

                        <div className="privacy-section">
                            <h2>Ваши права</h2>
                            <p>Все Ученики имеют следующие права:</p>
                            <ul>
                                <li><strong>Право на доступ:</strong> Вы можете запросить подтверждение и доступ к вашим личным данным, которые мы храним.</li>
                                <li><strong>Право на исправление:</strong> Вы можете потребовать исправления неточных личных данных.</li>
                                <li><strong>Право на забвение:</strong> При определенных обстоятельствах вы можете ограничить дальнейшее раскрытие ваших данных.</li>
                                <li><strong>Право на удаление:</strong> Вы можете запросить полное удаление вашей личной информации из нашей системы.</li>
                            </ul>
                        </div>

                        <div className="privacy-section">
                            <h2>Трансграничная передача данных</h2>
                            <p>
                                Ваша информация может храниться и обрабатываться на серверах и базах данных Amazon Web Service (AWS), расположенных в Индии, а также в других странах, в зависимости от местоположения наших партнеров и поставщиков услуг.
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>Претензии и контакты</h2>
                            <p>
                                Если у вас есть вопросы по этой Политике, вы хотите реализовать свои права или у вас есть жалобы, свяжитесь с нами по электронной почте: <a href="mailto:support@talktokrishna.ai">support@talktokrishna.ai</a>.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Privacy;

